/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { multiLineChartUtility } from '../../common/graph-utilities/MultiLineChart';
import { stackedBarChartUtility } from '../../common/graph-utilities/StackedBarChart';
import { groupBarChartUtility } from '../../common/graph-utilities/groupBarChartUtility';
import { arcChartUtility } from '../../common/graph-utilities/arcChart';
import { BarChartUtility } from '../../common/graph-utilities/barChart';

import useResizeObserver from '../../common/graph-utilities/useResizeObserver';
import { apiRequest } from '../../../utils/api_service';
import { API_URL } from '../../../constants/api';
import moment from 'moment';
export default function RenderChart ({
  identifier,
  chartConfig,
  legends,
  type = 'YTD',
  allowDrillDown = false
}) {
  // console.log("IN RENDER CHARTS", legends);
  const svgRef = useRef();
  const wrapperRef = useRef();
  // const dimensions = useResizeObserver(wrapperRef);
  if (
    moment(chartConfig.startDate).format('YYYY') ===
      moment(chartConfig.endDate).format('YYYY') &&
    moment(chartConfig.startDate).format('MM') ===
      moment(chartConfig.endDate).format('MM')
  ) {
    type = 'MTD';
  }

  const resetChart = () => {
    const temp = { ...drillDownConfig };
    temp.config = temp.config.filter(item => item.level === 1);
    temp.currentLevel = 1;
    temp.isDrillDown = false;
    temp.drillDownFilter = [];
    setDrillDown(temp);
  };

  const [drillDownConfig, setDrillDown] = useState({
    isDrillDown: false,
    defaultSettings: resetChart,
    config: [
      {
        key: '',
        type: type,
        accessor: chartConfig.multiLineChartAcessors,
        level: 1,
        seriesItem: {}
      }
    ],
    drillDownFilter: [],
    currentLevel: 1
  });

  const onDrillDown = (isDrillDown, key, type, accessor, level, seriesItem, data, keyTitle,drillDownKey) => {
    const temp = { ...drillDownConfig };
    const removeIndex = temp.config.map(item => item.level).indexOf(level);
    ~removeIndex && temp.config.splice(removeIndex, 1);
    ~removeIndex && temp.drillDownFilter.splice(removeIndex, 1);
    // console.log("after back");

    if ((chartConfig.widgetconfig || {}).isForPerformance !== true) {
      if (isDrillDown) {
        temp.config.push({ key: key, type, accessor, level, seriesItem, data,keyTitle,drillDownKey });
      }
      if (isDrillDown === false) {
        level = level - 1;
       // temp.config.push({ key: key, type, accessor, level, seriesItem, data });
      }

      temp.currentLevel = level;
      temp.isDrillDown = temp.currentLevel > 1
        ? true
        : isDrillDown;
      if ((temp.drillDownFilter || []).find(x => x.keyTitle === keyTitle) === undefined) {
        temp.drillDownFilter.push({ keyTitle: keyTitle, value: key, drillDownKey });
      } else {
        (temp.drillDownFilter || []).find(x => x.keyTitle === keyTitle).value = key;
      }
      // if (isDrillDown === false) {
      //   temp.drillDownFilter = [];
      // }
      // // console.log(drillDownConfig, temp);
      // console.log(chartConfig, temp);
      setDrillDown(temp);
    } else {
      getPerformanceData(
        chartConfig.widgetconfig,
        temp,
        isDrillDown,
        key,
        type,
        accessor,
        level,
        seriesItem,
        keyTitle,
        drillDownKey
      );
    }
  };
  
  useEffect(() => {
    let level = 1;
    if ((chartConfig.widgetconfig || {}).isForPerformance === true) {
      level =
        drillDownConfig.currentLevel > 1 ? drillDownConfig.currentLevel - 1 : 1;
      allowDrillDown = true;
    }
    switch (chartConfig.type) {
      case 'LineChart':
        // console.log(drillDownConfig, "here");

        multiLineChartUtility(
          chartConfig,
          identifier,
          onDrillDown,
          drillDownConfig,
          level,
          allowDrillDown
        );

        // console.log("data", chartConfig.data);
        break;
      case 'GroupBarChart':
        groupBarChartUtility(
          chartConfig,
          identifier,
          onDrillDown,
          drillDownConfig,
          1,
          allowDrillDown
        );
        break;

      case 'BarChart':
        // console.log("BarChart", chartConfig);
        BarChartUtility(
          chartConfig,
          identifier,
          onDrillDown,
          drillDownConfig,
          1,
          allowDrillDown
        );
        break;
      case 'StackBarChart':
        // console.log("StackBarChart", chartConfig);
        stackedBarChartUtility(
          chartConfig,
          identifier,
          onDrillDown,
          drillDownConfig,
          1,
          allowDrillDown
        );
        break;
      case 'PieChart':
        // console.log("PieChart", chartConfig);
        arcChartUtility(
          chartConfig,
          false,
          identifier,
          onDrillDown,
          drillDownConfig,
          1,
          allowDrillDown
        );
        break;
      case 'DonutChart':
        // console.log("DonutChart", chartConfig);
        arcChartUtility(
          chartConfig,
          true,
          identifier,
          onDrillDown,
          drillDownConfig,
          1,
          allowDrillDown
        );
        break;
      default:
        break;
    }
  });
  function getPerformanceData (
    widgetconfig,
    temp,
    isDrillDown,
    key,
    type,
    accessor,
    level,
    seriesItem,
    keyTitle,
    drillDownKey
  ) {
    if ((type || '') == '') {
      if (
        moment(chartConfig.startDate).format('YYYY') ===
          moment(chartConfig.endDate).format('YYYY') &&
        moment(chartConfig.startDate).format('MM') ===
          moment(chartConfig.endDate).format('MM')
      ) {
        type = 'MTD';
      } else {
        type = 'YTD';
      }
    }
    const params = {
      propertyId: localStorage.getItem('selectedPropertyId'),
      startDate: type == 'YTD' ? chartConfig.startDate : seriesItem.start,
      endDate: type == 'YTD' ? chartConfig.endDate : seriesItem.end,
      reportId: widgetconfig.reportId,
      type: type,
      isCalenderView: false,
      selectedAttribute: widgetconfig?.attributeId?.toString(),
      cloudOrgId: 2,
      dataHall: 0
    };
    apiRequest({
      url: API_URL.reports.PerformanceTrendByDate,
      params: params
    }).then(({ data: response }) => {
      const result = response;
      if (response.data !== undefined) {
        if (
          response.data[0].xAxisLabel !== undefined &&
          response.data[0].xAxisLabel !== null
        ) {
          chartConfig.xAxisLabel = response.data[0].xAxisLabel;
        }

        if (
          response.data[0].yAxisLabel !== undefined &&
          response.data[0].yAxisLabel !== null
        ) {
          chartConfig.yAxisLabel = response.data[0].yAxisLabel;
        }

        result.data = response.data[0].data;
      }
      const performanceConfig = {
        startDate: type == 'YTD' ? chartConfig.startDate : seriesItem.start,
        endDate: type == 'YTD' ? chartConfig.endDate : seriesItem.end,
        configuration: chartConfig.configuration,
        rawData: chartConfig.rawData,
        data: result.data,
        yAxisLabel: chartConfig.yAxisLabel,
        type: chartConfig.type,
        keys: result.barKeys,
        colors: result.colors,
        multiLineChartAcessors: result.chartAccessor,
        accessor: result.chartAccessor.mainAccessor,
        unit: result.unit,
        widgetconfig: widgetconfig,
        xAxisLabel: chartConfig.xAxisLabel
      };
      if (isDrillDown) {
        temp.config.push({
          key: key,
          type,
          accessor,
          level,
          seriesItem,
          performanceConfig,
          keyTitle,
          drillDownKey
        });
      }

      temp.currentLevel = type == 'YTD' ? 1 : level;
      temp.isDrillDown = isDrillDown;
      // console.log(drillDownConfig, temp, "In get Performance");
      // console.log(chartConfig, temp);
      setDrillDown(temp);
    });
  }

  return (
    <>
      {chartConfig && (
        <>
          <div
            className="row col-xs-12 no-padding content center-xs mt-5"
            style={{ marginTop: '5px' }}
          >
            <div id={identifier + '_xaxis'} className="col-xs content small-text">
              <b>{chartConfig.startDate + ' to ' + chartConfig.endDate}</b>
            </div>
          </div>
        </>
      )}
     
      <div
        id={identifier}
        ref={wrapperRef}
        style={{ width: '100%', textAlign: 'left', paddingLeft:'10px'}}
      >
        </div>
    
    </>
  );
}
